import type { UseFormSetValue } from "react-hook-form";
import { RetrievedCustomer } from "./subscription/_actions";
import { CheckoutForm } from "./types";
import { AddressForm } from "@/forms/address/AddressFields";
import { sanitizeText } from "@cappelendamm/e-commerce-services";

export const fillDataFactoryFields = (
  setValue: UseFormSetValue<CheckoutForm>,
  retrievedCustomer: RetrievedCustomer,
) => {
  const { firstName, lastName, street, postalCode, city, birthDate } =
    retrievedCustomer;

  setValue("delivery.firstName" as keyof CheckoutForm, firstName ?? "");
  setValue("delivery.lastName" as keyof CheckoutForm, lastName ?? "");
  setValue("delivery.street" as keyof CheckoutForm, street ?? "");
  setValue("delivery.postalCode" as keyof CheckoutForm, postalCode ?? "");
  setValue("delivery.city" as keyof CheckoutForm, city ?? "");
  if (birthDate) {
    setValue("birth.day", birthDate.day ?? "");
    setValue("birth.month", birthDate.month ?? "");
    setValue("birth.year", birthDate.year ?? "");
  }
};

export const sanitizeAddress = (address: AddressForm) => {
  return {
    ...address,
    firstName: sanitizeText(address.firstName),
    lastName: sanitizeText(address.lastName),
    street: sanitizeText(address.street),
    postalCode: sanitizeText(address.postalCode),
    city: sanitizeText(address.city),
    country: sanitizeText(address.country),
  };
};
